import { render, staticRenderFns } from "./ClientAvatar.vue?vue&type=template&id=51db6aa2&scoped=true&lang=html"
import script from "./ClientAvatar.vue?vue&type=script&lang=js"
export * from "./ClientAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51db6aa2",
  null
  
)

export default component.exports